<template>
  <BaseNoticeItem :button-text="$t('Update business entity')" :button-url="buttonUrl">
    <template #head>
      <strong>{{ $t('Update your business entity setup') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'Worksome no longer supports new hires via umbrella companies due to upcoming regulatory changes. Update your setup to continue receiving hiring offers.',
        )
      }}
      <!-- @todo Replace with CS-managed help article URL once available -->
      <a :href="helpArticleUrl" target="_blank" class="tw-underline">
        {{ $t('Learn more about your options →') }}
      </a>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const props = defineProps({
  complianceData: {
    type: Object,
    default: () => ({}),
  },
})

const { $t } = useTranslation()
const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#business-entity`
})

const helpArticleUrl = computed(() => props.complianceData?.helpArticleUrl || '#')
</script>
